import { CAROUSEL_NAME } from '../../constants';

export const LEFT_ARROW = `${CAROUSEL_NAME}__arrow--left`;
export const RIGHT_ARROW = `${CAROUSEL_NAME}__arrow--right`;
